/* eslint-disable */
import React, {useState} from 'react';
import 'contents/assets/scss/page/student.scss';
function ClassRegister() {
  return (
    <div className="com_class_retister">
      <div className="layout">
        <div className="layout__inner student_sec">
					{/* 20250218 퍼블 추가 & 수정 */}
          <article className="scroll">
            <div className="com_sec_tit__wrap">
              <p className="com_sec_tit dot">학생 정보</p>
              <button className="com_btn xs btn_special black">특별회원</button>
            </div>
            <hr className="com_divider" />
            <section className="com_board_search">
              <article className="search full">
                <input type="search" placeholder="학생 검색" className="input s type_search" />
                <button className="com_btn gray ws s icon_search"></button>
              </article>
            </section>
            <table className="com_board_list type_row">
              <colgroup>
                <col width="140px" />
                <col width="343px" />
              </colgroup>
              <tbody>
                <tr>
                  <th>학생명</th>
                  <td>
                    <input type="text" className="input" />
                  </td>
                </tr>
                <tr>
                  <th>학생 전화번호</th>
                  <td>
                    <input type="text" className="input" />
                  </td>
                </tr>
                <tr>
                  <th>모 폰</th>
                  <td>
                    <input type="text" className="input" />
                  </td>
                </tr>
                <tr>
                  <th>부 폰</th>
                  <td>
                    <input type="text" className="input" />
                  </td>
                </tr>
                <tr>
                  <th>담임</th>
                  <td>
                    <select className="select">
                      <option>김담임</option>
                    </select>
                  </td>
                </tr>
                <tr>
                  <th>
                    수업 위치
                    <br />
                    <span className="sub">(지도선택)</span>
                  </th>
                  <td>
                    <input type="text" />
                  </td>
                </tr>
                <tr>
                  <th>
                    주소(거주지)
                  </th>
                  <td>
                    <div className="com_input_wrap flex_row">
                      <input type="text" />
                      <button className="com_btn gray xs">우편번호</button>
                    </div>
                  </td>
                </tr>
                <tr>
                  <th>상세주소</th>
                  <td>
                    <input type="text" />
                  </td>
                </tr>
              </tbody>
            </table>
            <p className="com_sec_tit dot">영업 히스토리</p>
            <hr className="com_divider" />
            <ul className="history_list">
              <li>2023, 05, 12ㆍ수학ㆍ 담임홍보ㆍ비회원 문의ㆍ김담임123</li>
              <li>2023, 05, 12ㆍ수학ㆍ 담임홍보ㆍ비회원 문의ㆍ김담임123</li>
              <li>2023, 05, 12ㆍ수학ㆍ 담임홍보ㆍ비회원 문의ㆍ김담임123</li>
              <li>2023, 05, 12ㆍ수학ㆍ 담임홍보ㆍ비회원 문의ㆍ김담임123</li>
              <li>2023, 05, 12ㆍ수학ㆍ 담임홍보ㆍ비회원 문의ㆍ김담임123</li>
              <li>2023, 05, 12ㆍ수학ㆍ 담임홍보ㆍ비회원 문의ㆍ김담임123</li>
              <li>2023, 05, 12ㆍ수학ㆍ 담임홍보ㆍ비회원 문의ㆍ김담임123</li>
              <li>2023, 05, 12ㆍ수학ㆍ 담임홍보ㆍ비회원 문의ㆍ김담임123</li>
              <li>2023, 05, 12ㆍ수학ㆍ 담임홍보ㆍ비회원 문의ㆍ김담임123</li>
              <li>2023, 05, 12ㆍ수학ㆍ 담임홍보ㆍ비회원 문의ㆍ김담임123</li>
              <li>2023, 05, 12ㆍ수학ㆍ 담임홍보ㆍ비회원 문의ㆍ김담임123</li>
              <li>2023, 05, 12ㆍ수학ㆍ 담임홍보ㆍ비회원 문의ㆍ김담임123</li>
              <li>2023, 05, 12ㆍ수학ㆍ 담임홍보ㆍ비회원 문의ㆍ김담임123</li>
              <li>2023, 05, 12ㆍ수학ㆍ 담임홍보ㆍ비회원 문의ㆍ김담임123</li>
              <li>2023, 05, 12ㆍ수학ㆍ 담임홍보ㆍ비회원 문의ㆍ김담임123</li>
            </ul>
          </article>
          <div className="com_sec_tit__wrap">
            <p className="com_sec_tit dot">할인 & 결제 내역</p>
            <button className="com_btn xs lightOrange btn_list">DC 규정</button>
          </div>
          <table className="com_board_list type_row">
            <colgroup>
              <col width="140px" />
              <col width="343px" />
            </colgroup>
            <tbody>
              <tr>
                <th>DC 코드</th>
                <td>
                  <input type="text" className="input" />
                </td>
              </tr>
              <tr>
                <th>DC 사유</th>
                <td>
                  <input type="text" placeholder="사유 입력" />
                </td>
              </tr>
              <tr>
                <th>DC 금액</th>
                <td>
                  <input type="text" placeholder="금액 입력" />
                </td>
              </tr>
              <tr>
                <th>자동할인</th>
                <td className="com_blue_txt">
                  <b>190,000</b> 등록 기준일 기준 1년 지날때 자동할인
                </td>
              </tr>
              <tr>
                <th>총 결제 금액</th>
                <td></td>
              </tr>
            </tbody>
          </table>
        </div>
        <div className="layout__inner">
          <ClassSet />
			
          {/*<p className="com_tip right com_blue_txt">* 종료시간은 수업이 마치는 시간을 기준으로 입력해주세요.</p>*/}
          <div className="com_btn_wrap bottom">
            <button className="com_btn s full lightGray">+ 수업 추가 등록</button>
          </div>
        </div>
      </div>
    </div>
  );
}
const ClassSet = () => {
  //클래스 추가
  const [AdmissionChk, setAdmissionChk] = useState(1); //수시선택
  const [isOpen, setIsOpen] = useState(true);
  const classOpen = (event) => {
    // 👇️ toggle isActive state on click
    setIsOpen((current) => !current);
  };
	const [isOpen2, setIsOpen2] = useState(false);
  const classOpen2 = (event) => {
    // 👇️ toggle isActive state on click
    setIsOpen2((current) => !current);
  };
  return (
    <div className="class_list">
      <div className={`class_item  ${isOpen ? 'open' : ''}`}>
        <button type="button" className="icon_arrow_down" onClick={classOpen}></button>
        <div className="com_sec_tit__wrap">
          <p className="com_sec_tit dot">
            수업 1 <button className="btn_del_file"></button>
          </p>
        </div>
        <button className="com_btn xs lightOrange btn_list btn_class_price">수업료 단가표</button>
        <div className="toggle_cont">
          <p className="summary">화상 / 영어 / 고1일반 / 기본영어 / 완성수업N 14주 / 비교수업N / 2T / 수업료 : 780,000</p>
          <div className="table_wrap">
            <table className="com_board_list type_row">
              <colgroup>
                <col width="140px" />
                <col width="250px" />
                <col width="140px" />
                <col width="250px" />
              </colgroup>
              <tbody>
                <tr>
                  <th>수업변경</th>
                  <td>
                    <select className="select">
                      <option>담임 추가</option>
                    </select>
                  </td>
                  <th>수업등록</th>
                  <td>아웃바운드TMㅣ 김교사123, 담임324</td>
                </tr>
                <tr>
                  <th>인센티브 지급자</th>
                  <td colSpan="3">
                    <div className="com_input_wrap flex_row">
                      <section className="com_board_search">
                        <article className="search full">
                          <input type="search" placeholder="교사, 담임, 홍보 검색" className="input s type_search" />
                          <button className="com_btn gray ws icon_search"></button>
                        </article>
                      </section>
                      <div className="selected_item__wrap">
                        <p className="selected_item">
                          김교사 <button className="btn_del_file"></button>
                        </p>
                      </div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <th>수업소속 선택</th>
                  <td className="td_left" colSpan={3}>
                    <div className="check">
                      <input type="radio" name="class_register_rdo01" id="class_register_rdo01-01" className="com_chk circle" />
                      <label htmlFor="class_register_rdo01-01" onClick={() => setAdmissionChk(1)}>
                        본사
                      </label>
                      <input type="radio" name="class_register_rdo01" id="class_register_rdo01-02" className="com_chk circle" />
                      <label htmlFor="class_register_rdo01-02" onClick={() => setAdmissionChk(1)}>
                        부산
                      </label>
                      <input type="radio" name="class_register_rdo01" id="class_register_rdo01-03" className="com_chk circle" />
                      <label htmlFor="class_register_rdo01-03" onClick={() => setAdmissionChk(1)}>
                        원격과세
                      </label>
                      <input type="radio" name="class_register_rdo01" id="class_register_rdo01-04" className="com_chk circle" />
                      <label htmlFor="class_register_rdo01-04" onClick={() => setAdmissionChk(1)}>
                        원격비과세
                      </label>
                      <input type="radio" name="class_register_rdo01" id="class_register_rdo01-05" className="com_chk circle" />
                      <label htmlFor="class_register_rdo01-05" onClick={() => setAdmissionChk(0)}>
                        수시
                      </label>
                    </div>
                  </td>
                </tr>
                {AdmissionChk === 0 ? ( //수시 선택
                  <>
                    <tr>
                      <th rowSpan={3}>수업 선택</th>
                      <td className="td_left border_left" colSpan={3}>
                        <div className="check">
                          <input type="radio" name="rdo2" id="rdo2-01" className="com_chk circle" />
                          <label htmlFor="rdo2-01">생기부디자인</label>
                          <input type="radio" name="rdo2" id="rdo2-02" className="com_chk circle" />
                          <label htmlFor="rdo2-02">면접</label>
                          <input type="radio" name="rdo2" id="rdo2-03" className="com_chk circle" />
                          <label htmlFor="rdo2-03">자소서</label>
                          <input type="radio" name="rdo2" id="rdo2-04" className="com_chk circle" />
                          <label htmlFor="rdo2-04">논술</label>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td colSpan={3}>
                        <div className="check">
                          <input type="radio" name="rdo3" id="rdo3-01" className="com_chk circle" />
                          <label htmlFor="rdo3-01">정시컨설팅</label>
                          <input type="radio" name="rdo3" id="rdo3-02" className="com_chk circle" />
                          <label htmlFor="rdo3-02">수시컨설팅</label>
                          <input type="radio" name="rdo3" id="rdo3-03" className="com_chk circle" />
                          <label htmlFor="rdo3-03">수시제안컨설팅</label>
                        </div>
                      </td>
                    </tr>
                    {/*<tr>
                      <td colSpan={3}>
                        <p className="com_red_txt">* 이수업은 연장 수업입니다. (*2024, 01, 12 같은 수업을 진행하였습니다.)</p>
                      </td>
                    </tr>*/}
                    <tr>
                      <td colSpan={3}>
                        <div className="check">
                          <input type="radio" name="rdo4" id="rdo4-01" className="com_chk circle" />
                          <label htmlFor="rdo4-01">단품 수업</label>
                          <input type="radio" name="rdo4" id="rdo4-02" className="com_chk circle" />
                          <label htmlFor="rdo4-02">세트 수업</label>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <th>상품명</th>
                      <td colSpan={3}>
                        <select>
                          <option>선택</option>
                        </select>
                      </td>
                    </tr>
                    <tr>
                      <th>수업 방법</th>
                      <td colSpan={3}>
                        <div className="check">
                          <input type="radio" name="class_register_rdo02" id="class_register_rdo02-01" className="com_chk circle" />
                          <label htmlFor="class_register_rdo02-01">대면 수업</label>
                          <input type="radio" name="class_register_rdo02" id="class_register_rdo02-02" className="com_chk circle" />
                          <label htmlFor="class_register_rdo02-02">화상 수업</label>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <th rowSpan={2}>수업1</th>
                      <td colSpan={3}>* 1회수업시간 : 90분 * 수업체크 방법 : 보고서작성 * 수업방법 : 1:1수업</td>
                    </tr>
                    <tr>
                      <td colSpan={3}>* 수업단가 : 250,000 * 지급방법 : 정액제 * 지급메인 : 25,000 * 지급서브 : 10,000 비과세</td>
                    </tr>
                  </>
                ) : AdmissionChk === 1 ? ( //그외
                  <>
                    <tr>
                      <th rowSpan={4}>수업 선택</th>
                      <td className="td_left border_left" colSpan={3}>
                        <div className="check">
                          <input type="radio" name="rdo1" id="rdo1_01" className="com_chk circle" />
                          <label htmlFor="rdo1_01">국어</label>
                          <input type="radio" name="rdo1" id="rdo1_02" className="com_chk circle" />
                          <label htmlFor="rdo1_02">영어</label>
                          <input type="radio" name="rdo1" id="rdo1_03" className="com_chk circle" />
                          <label htmlFor="rdo1_03">수학</label>
                          <input type="radio" name="rdo1" id="rdo1_04" className="com_chk circle" />
                          <label htmlFor="rdo1_04">사탐</label>
                          <input type="radio" name="rdo1" id="rdo1_04" className="com_chk circle" />
                          <label htmlFor="rdo1_04">과탐</label>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td className="td_left border_left" colSpan={3}>
                        <select className="select">
                          <option value="고3 이상">고3 이상</option>
                        </select>
                      </td>
                    </tr>
                    <tr>
                      <td className="td_left border_left" colSpan={3}>
                        <div className="check">
                          <input type="checkbox" name="chk" id="chk_01" className="com_chk" />
                          <label htmlFor="chk_01">사회문화</label>
                          <input type="checkbox" name="chk" id="chk_02" className="com_chk" />
                          <label htmlFor="chk_02">경제</label>
                          <input type="checkbox" name="chk" id="chk_03" className="com_chk" />
                          <label htmlFor="chk_03">정치와 법</label>
                          <input type="checkbox" name="chk" id="chk_04" className="com_chk" />
                          <label htmlFor="chk_04">윤리와사상</label>
                          <input type="checkbox" name="chk" id="chk_05" className="com_chk" />
                          <label htmlFor="chk_05">생활과윤리</label>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td className="td_left border_left" colSpan={3}>
                        <div className="check">
                          <input type="checkbox" name="chk" id="chk_06" className="com_chk" />
                          <label htmlFor="chk_06">한국사</label>
                          <input type="checkbox" name="chk" id="chk_06" className="com_chk" />
                          <label htmlFor="chk_06">세계사</label>
                          <input type="checkbox" name="chk" id="chk_08" className="com_chk" />
                          <label htmlFor="chk_08">동아시아사</label>
                          <input type="checkbox" name="chk" id="chk_09" className="com_chk" />
                          <label htmlFor="chk_09">한국지리</label>
                          <input type="checkbox" name="chk" id="chk_10" className="com_chk" />
                          <label htmlFor="chk_10">세계지리</label>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <th>완성형수업</th>
                      <td className="td_left">
												<div className="com_flex_row">
                        <div className="check">
                          <input type="checkbox" name="chk3" id="chk3_01" className="com_chk " />
                          <label htmlFor="chk3_01">Y</label>

                        </div>
													
												<input type="text" className="input" value="8회" />
												</div>
                      </td>
                      <th>타임</th>
                      <td className="td_left">
                        <select className="select">
                          <option value="2T">2T</option>
                        </select>
                      </td>
                    </tr>
                    <tr>
                      <th>동시수업</th>
                      <td className="td_left">
                        <section className="com_board_search">
                          <article className="search full">
                            <input type="search" placeholder="학생 검색" />
                            <button className="com_btn gray ws xs icon_search"></button>
                          </article>
                        </section>
                      </td>
                      <th>1회 수업시간</th>
                      <td className="td_left">
                        <select className="select">
                          <option value="30분">30분</option>
                        </select>
                      </td>
                    </tr>
                    <tr>
                      <th>동시수업 인원</th>
                      <td>
                        <div className="selected_item__wrap">
                          <p className="selected_item">
                            김학생103 <button className="btn_del_file"></button>
                          </p>
                          <p className="selected_item">
                            김학생103 <button className="btn_del_file"></button>
                          </p>
                        </div>
                      </td>
                      <th>1회 수업료</th>
                      <td className="td_left">230,000</td>
                    </tr>
                    <tr>
                      <th>교사지목</th>
                      <td>
                        <div className="com_input_wrap flex_row">
                          <input type="checkbox" className="com_chk" />
                          <label />
                          <section className="com_board_search">
                            <article className="search full">
                              <input type="search" placeholder="학생 검색" />
                              <button className="com_btn gray ws xs icon_search"></button>
                            </article>
                          </section>
                        </div>
                      </td>
                      <th>수업료</th>
                      <td className="td_left td_point">
                        <b className="com_blue_txt">7230,000</b>
                      </td>
                    </tr>
                  </>
                ) : (
                  <></>
                )}
                {AdmissionChk === 0 ? ( //수시 선택
                  <tr>
                    <th>총 수업료</th>
                    <td className="td_left td_point" colSpan={3}>
                      <b className="com_blue_txt">7230,000</b>
                    </td>
                  </tr>
                ) : (
                  <></>
                )}
                <tr>
                  <th>메모</th>
                  <td colSpan={3} className="td_left">
									<input type="text" />
                  </td>
                </tr>
                <tr>
                  <th>수업가능일</th>
                  <td colSpan={3} className="td_left">
                    <div className="com_input_wrap flex_row">
                      <div className="com_check_date">
                        <input type="checkbox" className="chk_date" id="mon" />
                        <label htmlFor="mon">월</label>
                        <input type="checkbox" className="chk_date" id="tue" />
                        <label htmlFor="tue">화</label>
                        <input type="checkbox" className="chk_date" id="wed" />
                        <label htmlFor="wed">수</label>
                        <input type="checkbox" className="chk_date" id="thu" />
                        <label htmlFor="thu">목</label>
                        <input type="checkbox" className="chk_date" id="fri" />
                        <label htmlFor="fri">금</label>
                        <input type="checkbox" className="chk_date" id="sat" />
                        <label htmlFor="sat">토</label>
                        <input type="checkbox" className="chk_date" id="sun" />
                        <label htmlFor="sun">일</label>
                      </div>
                      <div className="sel_time">
                        <select className="select">
                          <option value="08시">08시</option>
                        </select>
                        <select className="select">
                          <option value="08시">30분</option>
                        </select>
                        <span className="divider">~</span>
                        <select className="select">
                          <option value="08시">08시</option>
                        </select>
                        <select className="select">
                          <option value="08시">30분</option>
                        </select>
                      </div>
                      <button className="btn_add"></button>
                      <button className="btn_minus_gray"></button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
			<div className={`class_item  ${isOpen2 ? 'open' : ''}`}>
        <button type="button" className="icon_arrow_down" onClick={classOpen2}></button>
        <div className="com_sec_tit__wrap">
          <p className="com_sec_tit dot">
            수업 2 <button className="btn_del_file"></button>
          </p>
        </div>
				<div className="toggle_cont">
          <p className="summary">화상 / 영어 / 고1일반 / 기본영어 / 완성수업N 14주 / 비교수업N / 2T / 수업료 : 780,000</p>
          <div className="table_wrap">
            <table className="com_board_list type_row">
              <colgroup>
                <col width="140px" />
                <col width="250px" />
                <col width="140px" />
                <col width="250px" />
              </colgroup>
              <tbody>
                <tr>
                  <th>수업변경</th>
                  <td>
                    <select className="select">
                      <option>담임 추가</option>
                    </select>
                  </td>
                  <th>수업등록</th>
                  <td>아웃바운드TMㅣ 김교사123, 담임324</td>
                </tr>
                <tr>
                  <th>인센티브 지급자</th>
                  <td colSpan="3">
                    <div className="com_input_wrap flex_row">
                      <section className="com_board_search">
                        <article className="search full">
                          <input type="search" placeholder="교사, 담임, 홍보 검색" className="input s type_search" />
                          <button className="com_btn gray ws icon_search"></button>
                        </article>
                      </section>
                      <div className="selected_item__wrap">
                        <p className="selected_item">
                          김교사 <button className="btn_del_file"></button>
                        </p>
                      </div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <th>수업소속 선택</th>
                  <td className="td_left" colSpan={3}>
                    <div className="check">
                      <input type="radio" name="class_register_rdo01" id="class_register_rdo01-01" className="com_chk circle" />
                      <label htmlFor="class_register_rdo01-01" onClick={() => setAdmissionChk(1)}>
                        본사
                      </label>
                      <input type="radio" name="class_register_rdo01" id="class_register_rdo01-02" className="com_chk circle" />
                      <label htmlFor="class_register_rdo01-02" onClick={() => setAdmissionChk(1)}>
                        부산
                      </label>
                      <input type="radio" name="class_register_rdo01" id="class_register_rdo01-03" className="com_chk circle" />
                      <label htmlFor="class_register_rdo01-03" onClick={() => setAdmissionChk(1)}>
                        원격과세
                      </label>
                      <input type="radio" name="class_register_rdo01" id="class_register_rdo01-04" className="com_chk circle" />
                      <label htmlFor="class_register_rdo01-04" onClick={() => setAdmissionChk(1)}>
                        원격비과세
                      </label>
                      <input type="radio" name="class_register_rdo01" id="class_register_rdo01-05" className="com_chk circle" />
                      <label htmlFor="class_register_rdo01-05" onClick={() => setAdmissionChk(0)}>
                        수시
                      </label>
                    </div>
                  </td>
                </tr>
                {AdmissionChk === 0 ? ( //수시 선택
                  <>
                    <tr>
                      <th rowSpan={3}>수업 선택</th>
                      <td className="td_left border_left" colSpan={3}>
                        <div className="check">
                          <input type="radio" name="rdo2" id="rdo2-01" className="com_chk circle" />
                          <label htmlFor="rdo2-01">생기부디자인</label>
                          <input type="radio" name="rdo2" id="rdo2-02" className="com_chk circle" />
                          <label htmlFor="rdo2-02">면접</label>
                          <input type="radio" name="rdo2" id="rdo2-03" className="com_chk circle" />
                          <label htmlFor="rdo2-03">자소서</label>
                          <input type="radio" name="rdo2" id="rdo2-04" className="com_chk circle" />
                          <label htmlFor="rdo2-04">논술</label>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td colSpan={3}>
                        <div className="check">
                          <input type="radio" name="rdo3" id="rdo3-01" className="com_chk circle" />
                          <label htmlFor="rdo3-01">정시컨설팅</label>
                          <input type="radio" name="rdo3" id="rdo3-02" className="com_chk circle" />
                          <label htmlFor="rdo3-02">수시컨설팅</label>
                          <input type="radio" name="rdo3" id="rdo3-03" className="com_chk circle" />
                          <label htmlFor="rdo3-03">수시제안컨설팅</label>
                        </div>
                      </td>
                    </tr>
                    {/*<tr>
                      <td colSpan={3}>
                        <p className="com_red_txt">* 이수업은 연장 수업입니다. (*2024, 01, 12 같은 수업을 진행하였습니다.)</p>
                      </td>
                    </tr>*/}
                    <tr>
                      <td colSpan={3}>
                        <div className="check">
                          <input type="radio" name="rdo4" id="rdo4-01" className="com_chk circle" />
                          <label htmlFor="rdo4-01">단품 수업</label>
                          <input type="radio" name="rdo4" id="rdo4-02" className="com_chk circle" />
                          <label htmlFor="rdo4-02">세트 수업</label>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <th>상품명</th>
                      <td colSpan={3}>
                        <select>
                          <option>선택</option>
                        </select>
                      </td>
                    </tr>
                    <tr>
                      <th>수업 방법</th>
                      <td colSpan={3}>
                        <div className="check">
                          <input type="radio" name="class_register_rdo02" id="class_register_rdo02-01" className="com_chk circle" />
                          <label htmlFor="class_register_rdo02-01">대면 수업</label>
                          <input type="radio" name="class_register_rdo02" id="class_register_rdo02-02" className="com_chk circle" />
                          <label htmlFor="class_register_rdo02-02">화상 수업</label>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <th rowSpan={2}>수업1</th>
                      <td colSpan={3}>* 1회수업시간 : 90분 * 수업체크 방법 : 보고서작성 * 수업방법 : 1:1수업</td>
                    </tr>
                    <tr>
                      <td colSpan={3}>* 수업단가 : 250,000 * 지급방법 : 정액제 * 지급메인 : 25,000 * 지급서브 : 10,000 비과세</td>
                    </tr>
                  </>
                ) : AdmissionChk === 1 ? ( //그외
                  <>
                    <tr>
                      <th rowSpan={4}>수업 선택</th>
                      <td className="td_left border_left" colSpan={3}>
                        <div className="check">
                          <input type="radio" name="rdo1" id="rdo1_01" className="com_chk circle" />
                          <label htmlFor="rdo1_01">국어</label>
                          <input type="radio" name="rdo1" id="rdo1_02" className="com_chk circle" />
                          <label htmlFor="rdo1_02">영어</label>
                          <input type="radio" name="rdo1" id="rdo1_03" className="com_chk circle" />
                          <label htmlFor="rdo1_03">수학</label>
                          <input type="radio" name="rdo1" id="rdo1_04" className="com_chk circle" />
                          <label htmlFor="rdo1_04">사탐</label>
                          <input type="radio" name="rdo1" id="rdo1_04" className="com_chk circle" />
                          <label htmlFor="rdo1_04">과탐</label>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td className="td_left border_left" colSpan={3}>
                        <select className="select">
                          <option value="고3 이상">고3 이상</option>
                        </select>
                      </td>
                    </tr>
                    <tr>
                      <td className="td_left border_left" colSpan={3}>
                        <div className="check">
                          <input type="checkbox" name="chk" id="chk_01" className="com_chk" />
                          <label htmlFor="chk_01">사회문화</label>
                          <input type="checkbox" name="chk" id="chk_02" className="com_chk" />
                          <label htmlFor="chk_02">경제</label>
                          <input type="checkbox" name="chk" id="chk_03" className="com_chk" />
                          <label htmlFor="chk_03">정치와 법</label>
                          <input type="checkbox" name="chk" id="chk_04" className="com_chk" />
                          <label htmlFor="chk_04">윤리와사상</label>
                          <input type="checkbox" name="chk" id="chk_05" className="com_chk" />
                          <label htmlFor="chk_05">생활과윤리</label>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td className="td_left border_left" colSpan={3}>
                        <div className="check">
                          <input type="checkbox" name="chk" id="chk_06" className="com_chk" />
                          <label htmlFor="chk_06">한국사</label>
                          <input type="checkbox" name="chk" id="chk_06" className="com_chk" />
                          <label htmlFor="chk_06">세계사</label>
                          <input type="checkbox" name="chk" id="chk_08" className="com_chk" />
                          <label htmlFor="chk_08">동아시아사</label>
                          <input type="checkbox" name="chk" id="chk_09" className="com_chk" />
                          <label htmlFor="chk_09">한국지리</label>
                          <input type="checkbox" name="chk" id="chk_10" className="com_chk" />
                          <label htmlFor="chk_10">세계지리</label>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <th>완성형수업</th>
                      <td className="td_left">
												<div className="com_flex_row">
                        <div className="check">
                          <input type="checkbox" name="chk3" id="chk3_01" className="com_chk " />
                          <label htmlFor="chk3_01">Y</label>

                        </div>
													
												<input type="text" className="input" value="8회" />
												</div>
                      </td>
                      <th>타임</th>
                      <td className="td_left">
                        <select className="select">
                          <option value="2T">2T</option>
                        </select>
                      </td>
                    </tr>
                    <tr>
                      <th>동시수업</th>
                      <td className="td_left">
                        <section className="com_board_search">
                          <article className="search full">
                            <input type="search" placeholder="학생 검색" />
                            <button className="com_btn gray ws xs icon_search"></button>
                          </article>
                        </section>
                      </td>
                      <th>1회 수업시간</th>
                      <td className="td_left">
                        <select className="select">
                          <option value="30분">30분</option>
                        </select>
                      </td>
                    </tr>
                    <tr>
                      <th>동시수업 인원</th>
                      <td>
                        <div className="selected_item__wrap">
                          <p className="selected_item">
                            김학생103 <button className="btn_del_file"></button>
                          </p>
                          <p className="selected_item">
                            김학생103 <button className="btn_del_file"></button>
                          </p>
                        </div>
                      </td>
                      <th>1회 수업료</th>
                      <td className="td_left">230,000</td>
                    </tr>
                    <tr>
                      <th>교사지목</th>
                      <td>
                        <div className="com_input_wrap flex_row">
                          <input type="checkbox" className="com_chk" />
                          <label />
                          <section className="com_board_search">
                            <article className="search full">
                              <input type="search" placeholder="학생 검색" />
                              <button className="com_btn gray ws xs icon_search"></button>
                            </article>
                          </section>
                        </div>
                      </td>
                      <th>수업료</th>
                      <td className="td_left td_point">
                        <b className="com_blue_txt">7230,000</b>
                      </td>
                    </tr>
                  </>
                ) : (
                  <></>
                )}
                {AdmissionChk === 0 ? ( //수시 선택
                  <tr>
                    <th>총 수업료</th>
                    <td className="td_left td_point" colSpan={3}>
                      <b className="com_blue_txt">7230,000</b>
                    </td>
                  </tr>
                ) : (
                  <></>
                )}
                <tr>
                  <th>메모</th>
                  <td colSpan={3} className="td_left">
									<input type="text" />
                  </td>
                </tr>
                <tr>
                  <th>수업가능일</th>
                  <td colSpan={3} className="td_left">
                    <div className="com_input_wrap flex_row">
                      <div className="com_check_date">
                        <input type="checkbox" className="chk_date" id="mon" />
                        <label htmlFor="mon">월</label>
                        <input type="checkbox" className="chk_date" id="tue" />
                        <label htmlFor="tue">화</label>
                        <input type="checkbox" className="chk_date" id="wed" />
                        <label htmlFor="wed">수</label>
                        <input type="checkbox" className="chk_date" id="thu" />
                        <label htmlFor="thu">목</label>
                        <input type="checkbox" className="chk_date" id="fri" />
                        <label htmlFor="fri">금</label>
                        <input type="checkbox" className="chk_date" id="sat" />
                        <label htmlFor="sat">토</label>
                        <input type="checkbox" className="chk_date" id="sun" />
                        <label htmlFor="sun">일</label>
                      </div>
                      <div className="sel_time">
                        <select className="select">
                          <option value="08시">08시</option>
                        </select>
                        <select className="select">
                          <option value="08시">30분</option>
                        </select>
                        <span className="divider">~</span>
                        <select className="select">
                          <option value="08시">08시</option>
                        </select>
                        <select className="select">
                          <option value="08시">30분</option>
                        </select>
                      </div>
                      <button className="btn_add"></button>
                      <button className="btn_minus_gray"></button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};
export default ClassRegister;
